import { Box, Label, NavList } from '@primer/react';
import { useContext } from 'react';
import { useSelector } from 'react-redux';
import { Link, useMatch, useResolvedPath } from 'react-router-dom';
import { useLanguage } from '../../hooks/useLanguage';
import { LayoutContext } from '../Layout';
import { RootState } from '../../state/reducers';
const NavItem = ({ to, children, defaultOpen }: any) => {
    const resolved = useResolvedPath(to)
    const isCurrent = useMatch({ path: resolved.pathname, end: true }) || `${window.location.pathname}/`.includes(`${resolved.pathname}/`)
    const { setHideSubNav } = useContext(LayoutContext);

    const handleClick = () => {
        if (setHideSubNav) {
            setHideSubNav(false);
        }
    };

    return (
        <NavList.Item as={Link} to={to} aria-current={isCurrent ? 'page' : undefined} defaultOpen={defaultOpen} onClick={handleClick}>
            {children}
        </NavList.Item>
    )
}
const Menu = () => {
    const { user_info } = useSelector((x: RootState) => x.auth)
    const { menu_group_id } = useSelector((x: RootState) => x.common)
    const { language } = useLanguage();
    return (
        <NavList>
            {user_info?.menus.filter(x => x.id === menu_group_id).map(menu => {
                return (
                    <NavList.Group title={language === "en" ? menu.name_en : menu.name} key={menu.id}>
                        {menu.items.map(subItem => {

                            return (
                                <NavItem to={`../../../${subItem.path}`} key={subItem.id} defaultOpen={subItem.items.length > 0 ? true : undefined}
                                // className="test"

                                >
                                    <NavList.LeadingVisual>
                                        <i className={`${subItem.icon}`}></i>
                                    </NavList.LeadingVisual>
                                    <Box sx={{
                                        fontSize: 13,
                                        fontWeight: 500
                                    }}>
                                        {language === "en" ? subItem.name_en : subItem.name}
                                    </Box>
                                    {subItem.tags &&
                                        <NavList.TrailingVisual>
                                            <Label variant='success'>{subItem.tags}</Label>
                                        </NavList.TrailingVisual>
                                    }
                                    {subItem.items.length > 0 &&
                                        <NavList.SubNav>
                                            {subItem.items.map(s => {
                                                return (
                                                    <NavItem key={s.id} to={`../../../${s.path}`} className="test">
                                                        <NavList.LeadingVisual>
                                                            <i className={`${s.icon}`}></i>
                                                        </NavList.LeadingVisual>
                                                        <Box sx={{
                                                            fontSize: 13,
                                                            fontWeight: 500
                                                        }}>
                                                            {language === "en" ? s.name_en : s.name}
                                                        </Box>

                                                        {s.tags &&
                                                            <NavList.TrailingVisual>
                                                                <Label>{s.tags}</Label>
                                                            </NavList.TrailingVisual>
                                                        }
                                                    </NavItem>
                                                )
                                            })}
                                        </NavList.SubNav>
                                    }
                                </NavItem>
                            )
                        })}

                    </NavList.Group>
                );
            })}
        </NavList>
    );
};

export default Menu;